import { apiUsersUrls } from "config/endPoints";
import apiManager from "managers/apiManager";
import notificationManager from "managers/notificationManager";
import { staticData } from 'managers/staticDataManager';

export const handleLogoutCall = (state, handleIsBusy, handleLogoutUser, notificationReference) => {
    // handleIsBusy(true);
    apiManager
        .post(apiUsersUrls.API_LOGOUT_URL)
        .then((response) => {
            if (response.data.isSuccess) {
                handleLogoutUser();
                notificationManager.error(null, notificationReference, staticData.loadTerms(state, "VW_ISSUER_IssuerNavbar_LogoutSuccess"));
            }
        })
        .finally(() =>{
            // handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(error, notificationReference);
            // handleIsBusy(false);
        });
};

export const getIssuersForUser = (userId, handleIsBusy, handleData, notificationReference) => {
    //handleIsBusy(true);
    apiManager
        .get(`${apiUsersUrls.API_ISSUERS_FOR_USER}/${userId}`)
        .then((response) => {
            if (response.data.isSuccess) {
                handleData(response.data.data);
            }
        })
        .finally(() => {
            //handleIsBusy(false);
        })
        .catch(function (error) {
            notificationManager.error(error, notificationReference);
            //handleIsBusy(false);
        });
};
